import cn from 'classnames/bind'
import { ChangeEvent, useCallback, useEffect, useMemo, useState } from 'react'

import PlainCheckbox from 'app/common/ui-next/plain-checkbox'
import PlainFieldset from 'app/common/ui-next/plain-fieldset'
import { Loading } from 'app/common/templates-next/page-template'

import { reduce } from 'ramda'
import styles from './DietFoodTypesCheckBoxes.module.scss'
import { DietFoodType } from 'app/dataTypes/org/dietFoodTypes'


const cx = cn.bind(styles)

type Props = {
  disabled?: boolean
  dietFoodTypesList: Array<DietFoodType>
  dietFoodTypesUsed: Array<DietFoodType>
}

export const DietFoodTypesCheckBoxes = ({
  disabled,
  dietFoodTypesList,
  dietFoodTypesUsed,
}: Props) => {
  const [checked, setChecked] = useState<Set<string>>(new Set())

  useEffect(() => {
    setChecked(new Set(dietFoodTypesUsed.map(({ id }) => id)))
  }, [dietFoodTypesUsed])

  const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    const { checked: nextItemState, value } = e.currentTarget
    setChecked((prevState) => {
      const nextState = new Set(prevState)
      if (nextItemState) {
        nextState.add(value)
      } else {
        nextState.delete(value)
      }
      return nextState
    })
  }, [])

  const [remove, add] = useMemo(() => {
    const ad = new Set<string>(checked)
    const rm = reduce((acc, { id }) => {
      if (ad.has(id)) {
        ad.delete(id)
      } else {
        acc.add(id)
      }
      return acc
    }, new Set<string>(), dietFoodTypesUsed)
    return [rm, ad]
  }, [dietFoodTypesUsed, checked])

  if (!dietFoodTypesList.length) {
    return (
      <div className={styles.root}>
        <Loading />
      </div>
    )
  }

  return (
    <PlainFieldset
      legend="Виды диетического питания:"
      name="dietFoodTypes"
      className={styles.root}
      legendClassName={styles.legend}
    >
      {dietFoodTypesList.map(({ id, title }) => (
        <div
          key={id}
          className={cx(styles.item, { remove: remove.has(id), add: add.has(id) })}
        >
          <PlainCheckbox
            label={title}
            value={id}
            name="dietFoodTypes"
            disabled={disabled}
            onChange={handleChange}
            checked={checked.has(id)}
          />
        </div>
      ))}
    </PlainFieldset>
  )
}

